<template>
    <v-row no-gutters class="mb-1">
        <v-col cols="12" md="5" class="pe-1">
            <v-autocomplete
                :label="$t('item')"
                v-model="line.item_id"
                :items="items"
                :loading="itemsLoading"
                item-text="display_name"
                item-value="id"
                :rules="[isRequired]"
                @update:search-input="$emit('update:items-search-input', $event)"
                dense
                outlined
                hide-details
            >
            </v-autocomplete>
        </v-col> 
        <v-col cols="12" md="2" class="pe-1">
            
            <v-autocomplete
                :label="$t('measure_unit')"
                v-model="line.measure_unit_id"
                :rules="[isRequired]"
                :items="measureUnits"
                item-text="abbreviation"
                item-value="id"
                dense
                outlined
                hide-details
            >
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="2">
            <v-text-field
                    :label="$t('available_quantity')"
                    :value="line.available_quantity"
                    :rules="[isRequired, isNumeric]"
                    dense
                    readonly
                    outlined
                    hide-details
                >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="d-flex">
            <v-text-field
                :label="$t('quantity')"
                v-model="line.quantity"
                :rules="[isRequired, isNumeric]"
                dense
                outlined
                hide-details
            >
            </v-text-field>
            <v-btn icon @click="handleDeleteLine">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { isRequired, isNumeric} from "../../../utils/validations"
import { getAvailableQuantity } from './../../../services/stock/item'

import { round } from 'lodash';
export default {
    props: {
       value: Object,
       items: Array,
       itemsLoading: Boolean,
       warehouseId: Number
    },
    data() {
        return {
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null,
                available_quantity: null
            },
            measureUnits: [],
            avaliableQuantityLoading: false,
        }
    },
    watch: {
        line: {
            handler(line) {
                this.$emit("input", {...line, base_quantity: this.baseQuantity});
            },
            deep: true
        },
        item: {
            handler(item) {
                if(!item) {
                    this.measureUnits = [];
                    return;
                }
                if(Array.isArray(item.measure_units)) {
                    this.measureUnits = item.measure_units;
                    return;
                }
                this.measureUnits = [];
            }
        },
        "line.item_id": {
            handler() {
                if(!this.line.item_id || !this.line.measure_unit_id ){
                    this.line.available_quantity = 0;
                    return;
                }
                this.fetchAvailableQuantity();
            }
        },
         "line.measure_unit_id": {
            handler() {
                if(!this.line.item_id || !this.line.measure_unit_id ){
                    this.line.available_quantity = 0;
                    return;
                }
                this.fetchAvailableQuantity();
            }
        }
        
    },
   
    methods: {
        isRequired,
        isNumeric,
        handleDeleteLine() {
            this.$emit("deleteLine")
        },
        fetchAvailableQuantity() {
            this.avaliableQuantityLoading = true;
            getAvailableQuantity(this.line.item_id, this.warehouseId, this.line.measure_unit_id).then(response => {
                this.line.available_quantity = round(response.data.value, 2)
            }).catch(() => {
                this.line.available_quantity = 0;
            }).finally(() => {
                this.avaliableQuantityLoading = false;
            })
        }
    },
    computed: {
        item() {
            return this.items.find(e => e.id == this.line.item_id)
        },
        // TODO: must calculate based on conversion of measure unit
        // will be put as same as quantity for testing.
        baseQuantity() {
            return this.line.quantity;
        }
    },
    created() {
        if(this.value) {
            this.line = {...this.line, ...this.value}
        }
    }
}
</script>

<style>

</style>